function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.8
},
/*#__PURE__*/
React.createElement("path", {
  d: "M11.294 20a.493.493 0 01-.416-.229l-4.112-6.528L.237 9.29a.492.492 0 01.057-.871L19.31.042a.492.492 0 01.65.645L11.745 19.7a.492.492 0 01-.413.3zM1.555 8.937l5.82 3.524a.493.493 0 01.161.158l3.676 5.837 7.347-17.01z"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M7.102 13.389a.492.492 0 01-.348-.84L19.154.144a.495.495 0 01.7.7l-12.405 12.4a.491.491 0 01-.347.145z"
}));

var SvgSendMessage = function SvgSendMessage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      fill: "currentColor",
      width: 20,
      height: 20,
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgSendMessage, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/send_message.ea1cb8b2.svg";
export { ForwardRef as ReactComponent };